import { useState,useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./dock.css";
import { dockOutApi, getDockViewApi, uploadDockAttachmentApi } from "./dock-api";
import driverImg from "../../assets/svg/driver.svg";
import close from "../../assets/svg/close.svg";
import truck from "../../assets/svg/truck.svg";
import img from "../../assets/svg/img.svg";
import upload from "../../assets/svg/upload.svg";
import CapturePictureModal from "../common/capture-picture";
import takePhoto from "../../assets/svg/camera-add.svg";

 const DockOutModal = ({dockId, onProceed,onCancel }) => {
    
    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",
          padding:'14px',
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "561px",
          height:"500px",
          overflowY: "auto",
        },
      };


 const [isCameraOpen, setIsCameraOpen] = useState(false);
    useEffect(() => {
     getDock()
     },[dockId]);   
   
    
    
          const [dockDetails, setDockDetails] = useState([]);
   const getDock = async () => {
       try {
         const response = await getDockViewApi(`${dockId}`);
         if (response.data.success === true) {
           setDockDetails(response.data.dock);
         }
         return response.data;
       } catch (err) {
         console.error("Error fetching category:", err);
       } finally {
       }
     };      

       const fileInputRef = useRef(null);
       const handleFileClick = () => {
         if (fileInputRef.current) {
           fileInputRef.current.click();
         } else {
           console.error("File input is not initialized.");
         }
       };

      const [base64FileList, setBase64FileList] = useState([]);
        const [urlImageList, setUrlImageList] = useState([]);
        const [removedImageList, setRemovedImageList] = useState([]);
      
       const handleFileChange = (event) => {
            const file = event.target.files[0];
            if (file && file.type.startsWith("image/")) {
              const reader = new FileReader();
              reader.onload = () => {
                const base64String = reader.result;
                const tempBase64FileList =[...base64FileList];          
                tempBase64FileList.push(base64String);
                setBase64FileList(tempBase64FileList)
                
              };
              reader.readAsDataURL(file);
            
          } else {
            alert("Please select a valid image file.");
          }
          };
     const dockOut = async () => {
     const response = await dockOutApi(dockId,{});
            if (response.status === 200) {
              if (response.data.success === true) {     
                 if(base64FileList.length>0){
              uploadAttachment(response.data.id)
            }           
                onProceed(response.data)                
              }
            }
          }
           const uploadAttachment = async (id) => {
                const response = await uploadDockAttachmentApi({"id": id, "type": "out", "attachments": base64FileList});
                if (response.status === 200) {
                  
                }
              }

              const onSuccessCapture = async (captureImage) => {
     const tempBase64FileList =[...base64FileList];          
          tempBase64FileList.push(captureImage);
          setBase64FileList(tempBase64FileList);
          setIsCameraOpen(false);
  };

    return ( <div style={modalStyle.overlay}>
       {isCameraOpen && <CapturePictureModal onSuccess={onSuccessCapture} onCancel={() => { setIsCameraOpen(false); }} />}
        <div style={modalStyle.modal}>
          
          <div style={{ color: "#ffffff" }}>
            
              <div className="dock-out-title style-justify-center">
    Confirm Dock out?
    </div>
      <div className="dock-out-sub-title style-justify-center">
    Are you sure want to dock out this vehicle right now?
    </div>
    <div className="dock-out-detail-box mt-2">
      <div className="style-justify-start">
        <div key={'base-image-'} className="mt-3" style={{position: "relative",width: '72px', height: '72px',}}> 
                                
                                 <img onClick={handleFileClick} src={truck} alt="profile" style={{cursor:'pointer', width: '72px', height: '72px', borderRadius:'100px', background:'#FFFFFF', padding:'10px' }} />   
                                   
             
              <input  ref={fileInputRef}
          type="file" accept=".jpg, .jpeg, .png"
          onChange={handleFileChange}
          style={{ display: "none" }} // Hide the actual file input
        />
                                  </div>
                                  <div className="ps-4"> 
        <div className="dock-out-vehicle-no">{dockDetails.vehicle_number??""}</div>
        <div className="dock-out-person"><img src={driverImg} alt="person"/><span className="ps-2 pt-2">{dockDetails.driver_name??""}</span></div>
      </div>
      </div>
       <div className="mt-2 d-flex" style={{gap:'12px'}}> 
<div className="dockout-detail-box">
<div className="dockout-title">Dock in time</div>
<div className="dockout-title-value">{dockDetails.dock_in_time??""}</div>
</div>

<div className="dockout-detail-box">
<div className="dockout-title">Duration</div>
<div className="style-justify-center">
<div className="dockout-title-value">{dockDetails.duration??"--"}</div>
<div className="ms-2 dockout-status">{dockDetails.dock_status??"--"}</div>
</div>
</div>

<div className="dockout-detail-box">
<div className="dockout-title">Lot Number</div>
<div className="dockout-title-value">{dockDetails.display_name??"--"}</div>
</div>
    </div>
    </div>
    <div>
       <div
              style={{
                borderRadius: "12px",
                padding: "20px",
                textAlign: "center",
                marginBottom: "20px",
                backgroundColor: "#F9F9F9",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop:'8px'
              }}
            >
               <div className="style-justify-center" style={{gap:'8px'}}>
              <div>
              <img
                src={img}
                alt="Upload icon"
                style={{ width: "40px", marginBottom: "10px" }}
              />
              <div style={{ fontSize: "14px", fontWeight: 500, color: "#888" }}>
                Upload proof image
              </div>
              </div>
              <button onClick={handleFileClick}
                style={{
                  marginTop: "10px",
                  color: "#d33",
                  border: "1px solid #E5E5E5",
                  padding: "10px 16px 10px 16px",
                  borderRadius: "37px",
                  background: "#FFFFFF",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "13px",
                  fontFamily: "epilogue",
                  fontWeight: "500",
                }}
              >
                <img
                  src={upload}
                  alt="Upload icon"
                  style={{ width: "16px", height: "16px" }}
                />
                Upload
              </button>
              <button onClick={()=>{setIsCameraOpen(true)}}
                        style={{
                          marginTop: "10px",
                          color: "#d33",
                          border: "1px solid #E5E5E5",
                          padding: "10px 16px 10px 16px",
                          borderRadius: "37px",
                          background: "#FFFFFF",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontSize: "13px",
                          fontFamily: "epilogue",
                          fontWeight: "500",
                        }}
                      >
                        <img
                          src={takePhoto}
                          alt="Capture"
                          style={{ width: "16px", height: "16px" }}
                        />
                        Take Photo
                      </button>
              </div>
            </div>
            <input  ref={fileInputRef}
                type="file" accept=".jpg, .jpeg, .png"
                onChange={handleFileChange}
                style={{ display: "none" }} // Hide the actual file input
              />
               <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
                                {urlImageList.map((urlImage, index) => (
                                  <div key={'url-image-'+index} className="mt-3" style={{position: "relative",}}> 
                                  <img src={urlImage!=null && urlImage!==''?urlImage.image: ""} alt="complaint" style={{ width: '72px', height: '72px', borderRadius:'14px' }} />
                                  <div
              style={{
                position: "absolute",
                top: "1px",
                right: "1px", 
              }}
            >
              <div style={{ display:'flex',justifyContent:"start", alignItems:"center",}}>
               <img src={close} alt="" style={{cursor: "pointer",}} onClick={()=>{
              const tempRemoved=[...removedImageList];
              tempRemoved.push(urlImage.id)
               removedImageList(tempRemoved);
                const tempURLImageList=[...urlImageList];
                tempURLImageList.splice(index,1);
               
                setUrlImageList(tempURLImageList);         
                }}/>
              </div>
            </div> 
                                </div>
                                ))}  
                                {base64FileList.map((baseImage, index) => (
                                  <div key={'base-image-'+index} className="mt-3" style={{position: "relative",}}> 
                                  <img src={baseImage!=null && baseImage!==''?baseImage: ""} alt="complaint" style={{ width: '72px', height: '72px', borderRadius:'14px' }} />
                                  <div
              style={{
                position: "absolute",
                top: "1px",
                right: "1px", 
              }}
            >
              <div style={{ display:'flex',justifyContent:"start", alignItems:"center",}}>
               <img src={close} alt="" style={{cursor: "pointer",}} onClick={()=>{
                const tempImageList=[...base64FileList];
                tempImageList.splice(index,1);
                setBase64FileList(tempImageList);
                
                }}/>
              </div>
            </div> 
                                </div>
                                ))}
                                </div>
    </div>
    <div className="style-justify-center mt-3" style={{gap:'8px'}}>
      <div onClick={dockOut} className="dockout-confirm">Yes, Confirm</div>
      <div onClick={onCancel} className="dockout-cancel">No, Don’t</div>
    </div>
           
          </div>
        </div>
      </div>);

}

export default DockOutModal;